export const ppn = +process.env.VUE_APP_PPN_NUMERATOR
export const pph = +process.env.VUE_APP_PPH_NUMERATOR
